import { getBackendUrl } from "@Utils";
import { useRef, useState } from "react";
import css from "../Workflows.module.css";

import UserNameTagComponent from "../../../../../cubeComponent/html/UserNameTagComponent";
import SlickGrid from "@CubeComponents/html/SlickGrid";
import { createRoot } from "react-dom/client";
import { useTranslation } from "react-i18next";

function UsersListInSpace({ spaceId, selectUsers, disabledUserIds = [] }) {
  const dataGrid = useRef(null);
  const { t } = useTranslation();

  const [spaceUsersQuery] = useState({
    spaceId,
    params: {
      spaceId,
    },
  });
  const selectionEvents = (args) => {
    const rowData = dataGrid.current.slickGrid.getDataItem(args.detail.args.changedSelectedRows[0]);
    if (rowData) {
      if (disabledUserIds.includes(rowData.userId)) {
        args.cancel = true;
        return;
      }

      const selectedRecords = dataGrid.current.dataView.getAllSelectedItems();
      selectUsers(selectedRecords);
    }
  };

  const userNameTemplate = (args) => {
    const container = document.createElement("div");
    const root = createRoot(container);
    const { userId } = args;

    root.render(<UserNameTagComponent id={userId} />);
    return container;
  };

  const columnDefinitions = useRef([
    {
      field: "userName",
      id: "fullName",
      name: t("Users"),
      _valueGetter: (params) => params.fullName,
      formatter: (data, params, a, b, value) => userNameTemplate(value),
      filterType: "Text",
    },
    {
      field: "companyName",
      id: "company",
      name: t("Organization"),
      filterType: "Text",
      _valueGetter: (params) => params.companyName,
    },
  ]);

  return (
    <div className={css.gridClassAddUser}>
      <SlickGrid
        ref={dataGrid}
        customGridStyle
        remoteDataSource={`${getBackendUrl()}/workflows/getSpaceUsersList`}
        query={spaceUsersQuery}
        columnDefinitions={columnDefinitions.current}
        disabledIds={disabledUserIds}
        onSelectedRowsChanged={selectionEvents}
      />
    </div>
  );
}

export default UsersListInSpace;
